// src/components/Gallery/Scene/components/AvatarTest.jsx
import React, { useState, useRef } from 'react';
import { useThree, useFrame } from '@react-three/fiber';
import * as THREE from 'three';
import GLBAvatar from './VRMAvatar';

const AvatarTest = ({ movementSystem, onAvatarLoaded }) => {
  const [avatarPosition, setAvatarPosition] = useState([0, 0, 0]);
  const [rotation, setRotation] = useState(0);
  const [movementState, setMovementState] = useState({
    isMoving: false,
    isSprinting: false,
    speed: 0,
    velocity: 0
  });
  
  // Update avatar based on unified movement system
  useFrame(() => {
    if (movementSystem) {
      // Get character position and rotation from unified system
      const characterPosition = movementSystem.getCharacterPosition();
      const characterRotation = movementSystem.getCharacterRotation();
      const characterMovementState = movementSystem.getMovementState();
      
      // Update avatar position
      setAvatarPosition([
        characterPosition.x,
        characterPosition.y,
        characterPosition.z
      ]);
      
      // Update avatar rotation
      setRotation(characterRotation.y);
      
      // Update movement state
      setMovementState(characterMovementState);
    }
  });
  
  return (
    <>
      {/* Real model with animations - only show in third person */}
      {movementSystem?.getViewMode() === 'third' && (
        <group position={avatarPosition} rotation={[0, rotation, 0]}>
          <GLBAvatar 
            position={[0, 0, 0]}
            movementState={movementState}
            vrmUrl={process.env.PUBLIC_URL + "/models/yea-host.glb"}
            animationUrl={process.env.PUBLIC_URL + "/models/yea-animation.glb"}
            onAvatarLoaded={onAvatarLoaded}
          />
        </group>
      )}
      
      {/* Placeholder mesh for testing - uncomment if needed */}
      {/* <mesh ref={placeholderRef} position={[avatarPosition[0], avatarPosition[1], avatarPosition[2]]}>
        <capsuleGeometry args={[0.5, 1.0, 4, 8]} />
        <meshStandardMaterial color="blue" />
      </mesh> */}
    </>
  );
};

export default AvatarTest;